/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import { SVGIcon } from '@ba/ba-ui-carbon-toolkit';
import PropTypes from 'util/PropTypes';
import Card from './Card';
import StringResources from 'nls/StringResources';

import dataRelationships128 from '@ba/ba-graphics/dist/illustrations-js/data-relationships-card_128';

class StartingPointsCard extends Component {
	constructor(props) {
		super(props);
	}

	render() {

		const {
			onClick,
			isSelected
		} = this.props;

		const spTitle = StringResources.get('startingPoints_data_relationships_thumbnail_title');
		const view = <SVGIcon className="startingPointsThumb" iconId={dataRelationships128.id} width={190} height={100} />;

		return (
			<div
				className="card-list-view__starting-points"
				data-entry-type="starting-points"
				title={spTitle}
				aria-label={spTitle}
			>
				<Card
					id="starting_points"
					title={spTitle}
					tabIndex="0"
					hasFooter={false}
					isSelected={isSelected}
					onClick={onClick}
					view={view} />
			</div>
		);
	}
}

StartingPointsCard.propTypes = {
	onClick: PropTypes.func,
	isSelected: PropTypes.bool
};

Card.defaultProps = {
	onClick: () => {},
	isSelected: true
};

export default StartingPointsCard;



// WEBPACK FOOTER //
// ./src/js/components/cards/StartingPointsCard.js